
$(function () {
    $(".widget-cbox .toggle-handle").click(function () {
        var $parent = $(this).parent().parent();
        var expanded = $parent.hasClass("expanded");

        if (expanded) {
            $parent.removeClass("expanded");
        }
        else {
            $parent.addClass("expanded");
        }
    })
})